export enum UniPreviewFileType {
  image = 'image',
  document = 'document',
  video = 'video'
}
